/**
 * ATTENTION! This file is auto-generated for the 'telephony' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { TelephonyConnectionRepository } from '../server/repositories/TelephonyConnectionRepository';
import type { TelephonySyncStateRepository } from '../server/repositories/TelephonySyncStateRepository';
import type { TelephonyLineRepository } from '../server/repositories/TelephonyLineRepository';
import type { TelephonyAgentRepository } from '../server/repositories/TelephonyAgentRepository';
import type { TelephonyCallRepository } from '../server/repositories/TelephonyCallRepository';
import type { TelephonyCallLinkRepository } from '../server/repositories/TelephonyCallLinkRepository';
import type { TelephonySyncLockRepository } from '../server/repositories/TelephonySyncLockRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type TelephonyConnectionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelephonyConnectionRepository>;
export function useTelephonyConnectionRepository(): TelephonyConnectionRepositoryClient { return makeRepositoryProxy<TelephonyConnectionRepositoryClient>('telephony::TelephonyConnectionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelephonyConnectionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telephonyConnectionRepository = useTelephonyConnectionRepository();

type TelephonySyncStateRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelephonySyncStateRepository>;
export function useTelephonySyncStateRepository(): TelephonySyncStateRepositoryClient { return makeRepositoryProxy<TelephonySyncStateRepositoryClient>('telephony::TelephonySyncStateRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelephonySyncStateRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telephonySyncStateRepository = useTelephonySyncStateRepository();

type TelephonyLineRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelephonyLineRepository>;
export function useTelephonyLineRepository(): TelephonyLineRepositoryClient { return makeRepositoryProxy<TelephonyLineRepositoryClient>('telephony::TelephonyLineRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelephonyLineRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telephonyLineRepository = useTelephonyLineRepository();

type TelephonyAgentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelephonyAgentRepository>;
export function useTelephonyAgentRepository(): TelephonyAgentRepositoryClient { return makeRepositoryProxy<TelephonyAgentRepositoryClient>('telephony::TelephonyAgentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelephonyAgentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telephonyAgentRepository = useTelephonyAgentRepository();

type TelephonyCallRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelephonyCallRepository>;
export function useTelephonyCallRepository(): TelephonyCallRepositoryClient { return makeRepositoryProxy<TelephonyCallRepositoryClient>('telephony::TelephonyCallRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelephonyCallRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telephonyCallRepository = useTelephonyCallRepository();

type TelephonyCallLinkRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelephonyCallLinkRepository>;
export function useTelephonyCallLinkRepository(): TelephonyCallLinkRepositoryClient { return makeRepositoryProxy<TelephonyCallLinkRepositoryClient>('telephony::TelephonyCallLinkRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelephonyCallLinkRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telephonyCallLinkRepository = useTelephonyCallLinkRepository();

type TelephonySyncLockRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<TelephonySyncLockRepository>;
export function useTelephonySyncLockRepository(): TelephonySyncLockRepositoryClient { return makeRepositoryProxy<TelephonySyncLockRepositoryClient>('telephony::TelephonySyncLockRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useTelephonySyncLockRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const telephonySyncLockRepository = useTelephonySyncLockRepository();

type saveTelephonyCredentialsType = typeof import('../server/functions/saveTelephonyCredentials').saveTelephonyCredentials;
export const saveTelephonyCredentials: RpcFunctionClient<saveTelephonyCredentialsType> = makeFunctionProxy<saveTelephonyCredentialsType>('telephony::saveTelephonyCredentials');

type testTelephonyConnectionType = typeof import('../server/functions/testTelephonyConnection').testTelephonyConnection;
export const testTelephonyConnection: RpcFunctionClient<testTelephonyConnectionType> = makeFunctionProxy<testTelephonyConnectionType>('telephony::testTelephonyConnection');

type syncTelephonyDirectoryType = typeof import('../server/functions/syncTelephonyDirectory').syncTelephonyDirectory;
export const syncTelephonyDirectory: RpcFunctionClient<syncTelephonyDirectoryType> = makeFunctionProxy<syncTelephonyDirectoryType>('telephony::syncTelephonyDirectory');

type importTelephonyHistoryType = typeof import('../server/functions/importTelephonyHistory').importTelephonyHistory;
export const importTelephonyHistory: RpcFunctionClient<importTelephonyHistoryType> = makeFunctionProxy<importTelephonyHistoryType>('telephony::importTelephonyHistory');
